import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import Body1 from '@twicapp/ui/components/Body1';
import Title1 from '@twicapp/ui/components/Title1';
import { SCREEN_WIDTHS } from '@twicapp/ui/constants/breakpoints';

import { getConversionFromUSD } from 'utils/employee';
import { getImageURL } from 'utils/cloudinary';

import PriceComparison from './PriceComparison';

import { STORE_PAGE_ELEMENTS } from 'constants/testSelectors';

import { VendorRoutes } from 'utils/routeGenerator';

const Card = styled.div.attrs({
  'data-testid': STORE_PAGE_ELEMENTS.PRODUCT_CARD,
})`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  width: 277px;

  @media (width: ${SCREEN_WIDTHS.LAPTOP}) {
    width: 207px;
  }

  @media (width: ${SCREEN_WIDTHS.TABLET_PORTRAIT}) {
    width: 100%;
  }
`;

const Picture = styled.img`
  width: 100%;
  height: 155px;
  object-fit: cover;
  margin-bottom: 15px;
  border-radius: 7px;
`;

const CompanyName = styled(Body1)`
  display: block;
  color: ${({
    theme: {
      colors: {
        text: { secondary },
      },
    },
  }) => secondary};
  margin-bottom: 10px;
`;

const ProductName = styled(Title1)`
  margin-bottom: 10px;
`;

const ProductCard = ({
  id,
  company,
  product,
  vendor,
  title,
  image,
  employee_country_exchange_rate = 1,
  onClick,
}: {
  id: string;
  company: {
    features: {
      stipend_config: {
        display_as_amount: boolean;
      };
    };
  };
  product: {
    id: string;
    term: string;
    special_price: number;
    msrp: number;
  };
  vendor: {
    id: string;
    coupon_code_available: boolean;
    coupon_code_locations: string[];
    title: string;
  };
  title: string;
  image: string | { image_url: string };
  employee_country_exchange_rate?: number;
  onClick?: () => void;
}) => {
  const history = useHistory();
  const onClickCard = () => {
    if (onClick) {
      onClick();
    }
    history.push(
      VendorRoutes.detail({
        vendor_id: vendor.id,
        product_id: product.id,
      })
    );
  };
  const does_price_vary =
    vendor.coupon_code_available &&
    vendor.coupon_code_locations &&
    vendor.coupon_code_locations.length > 0;

  return (
    <Card onClick={onClickCard}>
      <Picture src={getImageURL(image, { height: 190 })} alt={product.id} />
      <CompanyName>{vendor.title}</CompanyName>
      <ProductName>{title}</ProductName>
      {does_price_vary ? (
        <Title1>Price varies by location</Title1>
      ) : (
        <PriceComparison
          old_price={getConversionFromUSD({
            usd_price: product.msrp,
            employee_country_exchange_rate,
          })}
          new_price={getConversionFromUSD({
            usd_price: product.special_price,
            employee_country_exchange_rate,
          })}
          term={product.term}
          company={company}
          saving_bubble={false}
        />
      )}
    </Card>
  );
};

export default ProductCard;
